import React from 'react'

import { LayerManager } from '@surglogs-app/ui'
import { DefaultCancelChangesDialog } from '@surglogs-app/ui.dialog'

import { useBeforeLeavePrompt } from './useBeforeLeavePrompt'

interface UseDefaultBeforeLeavePromptOpts {
  onConfirm?: () => void
  onClose?: null | (() => void)
  ignoreSilentChanges?: boolean
}

export function useDefaultBeforeLeavePrompt(
  promptCondition: () => boolean,
  opts?: UseDefaultBeforeLeavePromptOpts,
) {
  return useBeforeLeavePrompt(
    ({ answer }) => (
      <LayerManager>
        {({ zIndex, increaseBy }) => (
          <DefaultCancelChangesDialog
            {...{
              zi: zIndex + increaseBy,
              onConfirm: () => {
                opts?.onConfirm?.()
                answer(true)
              },
              onCancel: () => answer(false),
            }}
          />
        )}
      </LayerManager>
    ),
    promptCondition,
    {
      onClose: opts?.onClose,
      ignoreSilentChanges: opts?.ignoreSilentChanges,
    },
  )
}
